import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './components/AuthProvider';
import { TenantProvider } from './components/TenantProvider';
import { monitor } from './lib/monitoring';
import { swManager } from './lib/serviceWorker';
import './index.css';

// Initialize monitoring
if (process.env.NODE_ENV === 'production') {
  monitor.trackPerformance('app_init', performance.now());
  
  // Register service worker
  swManager.register().catch(error => {
    monitor.logError('Failed to register service worker', { error });
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <TenantProvider>
            <Toaster position="top-right" />
            <App />
          </TenantProvider>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>
);